import { useQuery } from '@tanstack/react-query';
import { getApiBaseUrl } from '@core/tenant/getSubdomainPrefix';
import { fetchRestaurantGroup } from '../api/restaurantGroups';

/**
 * Loads a restaurant group by slug. Slug-keyed, low-churn data → cache it
 * so a viral event link doesn't hammer the API.
 */
export function useRestaurantGroup(slug: string) {
  const apiBaseUrl = getApiBaseUrl();
  return useQuery({
    queryKey: ['restaurant-group', slug],
    queryFn: () => fetchRestaurantGroup(slug, apiBaseUrl),
    staleTime: 5 * 60 * 1000,
    gcTime: 30 * 60 * 1000,
    retry: 1,
    enabled: Boolean(slug),
  });
}
